// Modal.js
import React from 'react';

/**
 * The create / edit popup of the WhatsApp screens. Every one opens at the same size (--wa-popup-width x --wa-popup-height in
 * Global.css, which follow the window), with the X pinned at the top; whatever the form holds scrolls inside the popup,
 * vertically and horizontally, as far as the data needs.
 */
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) {
    return null; // Do not render if not open
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content wa-popup" role="dialog" aria-modal="true">
        <button className="close-button" onClick={onClose} aria-label="Close">X</button>
        <div className="wa-popup-scroll">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
